import React, { Suspense } from 'react';
import { importRemote } from 'module-federation-import-remote';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';
import { mfeLazyLoadErrorHandler } from 'utils/mfe';
import { PageLoading } from '@dtna/dvs-core-dcp-ui-libraries';

const VehicleHealthIndex = React.lazy(() => importRemote<any>({
  url: getMfeUrl('VEHICLE_HEALTH_INDEX'),
  scope: 'VehicleHealthIndex',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadErrorHandler));

export default function VehicleHealthIndexWrapper({ navbarLoaded }: { navbarLoaded: boolean }) {
  return (
    <Suspense fallback={<PageLoading navbarLoaded={navbarLoaded} />}>
      <VehicleHealthIndex />
    </Suspense>
  );
}
